import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { Map } from "ol";
import { EventsKey } from "ol/events";
import { unByKey } from "ol/Observable";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  readMapSettings,
  updateMapSettings,
} from "../../functions/localMapSettings";
import { CustomMapEventTypes } from "../../types/map";

interface Props {
  map?: Map;
}

export const IceLevelExtraSettings = ({ map }: Props): JSX.Element => {
  const { t } = useTranslation("ice-layer-settings");
  const [settingsChanged, setSettingsChanged] = React.useState(false);
  const [showIceLegend, setShowIceLegend] = React.useState(
    readMapSettings("iceLegend"),
  );

  React.useEffect(() => {
    let key: EventsKey | EventsKey[];
    if (map) {
      key = map.on(CustomMapEventTypes.SettingsChanged, () =>
        setSettingsChanged((prev) => !prev),
      );
    }
    return () => {
      unByKey(key);
    };
  }, [map]);

  React.useEffect(() => {
    setShowIceLegend(readMapSettings("iceLegend"));
  }, [settingsChanged]);

  const udpateMap = () => {
    map?.dispatchEvent(CustomMapEventTypes.SettingsChanged);
  };

  return (
    <Grid item>
      <FormControlLabel
        control={
          <Checkbox
            checked={showIceLegend ?? false}
            onChange={(_e, v) => {
              updateMapSettings({ iceLegend: v });
              udpateMap();
            }}
          />
        }
        label={t("show-ice-legend")}
      />
    </Grid>
  );
};
